import { getBusinessesBySequenceId } from '@/services/sequencesService';
import { useRef, useState } from 'react';
import { useSequencesContext } from '../SequencesContext';
import { BUSINESS_PER_SCROLL } from '../config';

export function useBusinesses() {
	const { selectedSequence, setSelectedSequence } = useSequencesContext();

	const [isLoading, setIsLoading] = useState(false);
	const [firstLoading, setFirstLoading] = useState(true); // This is used for the infinite scrolling not triggering the loading spinner

	const loadingBusiness = useRef(false);
	const businessesPage = useRef(2); // It should start fetching from the second page since we already have the first page

	const fetchBusinesses = ({
		first,
		search
	}: { first?: boolean; search?: string } = {}) => {
		if (!selectedSequence?.id || loadingBusiness.current) return;

		loadingBusiness.current = true;
		setIsLoading(true);

		const page = first ? 1 : businessesPage.current;

		getBusinessesBySequenceId({
			campaignId: selectedSequence.id,
			limit: BUSINESS_PER_SCROLL,
			skip: (page - 1) * BUSINESS_PER_SCROLL,
			searchName: search || ''
		})
			.then(res => {
				const businesses = res.data?.data.businesses || [];

				loadingBusiness.current = false;
				businessesPage.current = first ? 2 : page + 1;
				// @ts-ignore
				setSelectedSequence(prev => ({
					...prev,
					businesses:
						page === 1
							? businesses
							: prev.businesses?.concat(businesses)
				}));
			})
			.finally(() => {
				setIsLoading(false);

				if (firstLoading) setFirstLoading(false);
			});
	};

	return {
		fetchBusinesses,
		isLoading,
		firstLoading,
		setFirstLoading
	};
}
